<template>
    <div class="layout__width-90 layout__padding-clear">
        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-80 layout__padding-40px-0">
                <div class="text__colour-teal text__size-50 text__style-bold-700">Digital Products</div>
            </div>
        </div>

        <div class="component__product__card">
            <router-link class="link__colour-black" to="/products/digital/social-media">
                <div class="component__product__card-body">
                    <div class="component__product__card-overlay"></div>
                    <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/socialmediamock.jpg">
                    <div class="component__product__card-subtitle-text">Social Media</div>
                    <div class="component__product__card-overlay-text">Connect with your customers with great social media content</div>
                </div>
            </router-link>
        </div>

        <div class="component__product__card">
            <router-link class="link__colour-black" to="/products/digital/email-signature">
                <div class="component__product__card-body">
                    <div class="component__product__card-overlay"></div>
                    <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/email-sig-720x500.png">
                    <div class="component__product__card-subtitle-text">Email Signatures</div>
                    <div class="component__product__card-overlay-text">A great email can go a long way</div>
                </div>
            </router-link>
        </div>


        <div class="component__product__card">
            <router-link class="link__colour-black" to="/products/digital/web-banners">
                <div class="component__product__card-body">
                    <div class="component__product__card-overlay"></div>
                    <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png">
                    <div class="component__product__card-subtitle-text">Web Banners</div>
                    <div class="component__product__card-overlay-text">Customised web banners branded to your business</div>
                </div>
            </router-link>
        </div>

        <div class="component__product__card">
            <router-link class="link__colour-black" to="/products/digital/microsites">
                <div class="component__product__card-body">
                    <div class="component__product__card-overlay"></div>
                    <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg">
                    <div class="component__product__card-subtitle-text">Microsites</div>
                    <div class="component__product__card-overlay-text">Reach the widest audience possible with a full-featured microsite</div>
                </div>
            </router-link>
        </div>


        <div class="component__product__card">
            <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                <div class="component__product__card-body">
                    <div class="component__product__card-overlay"></div>
                    <img class="layout__width-100" src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png">
                    <div class="component__product__card-subtitle-text">Animated Brochures</div>
                    <div class="component__product__card-overlay-text">An impressive company brochure matters, but it’s not always easy to get a printed product into a client’s hands</div>
                </div>
            </router-link>
        </div>
    </div>

</template>

<script>

    export default {
        name: "Digital",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    };
</script>